import { useQuery } from "@tanstack/react-query";
import { RePrintApiService } from "./reprint.api";

export const useRePrintList = (payload: any) => {
    
    // SELECT ALL LABEL QUERY
    const SelectAllQuery = useQuery({
        queryKey: ["reprint-label-SelectAll", payload],
        queryFn: () => RePrintApiService.selectAll(payload),
    });

    return {
        SelectAllQuery,
    };
};